/**
 * This method is used to listen to selects that has the value of other option
 *  and shows or hide the other value input
 * @param field
 * @param enums
 */
window.otherValueManipulationEventRegister = (field, enums, callback = null) => {
    $(document).on('change', `#${field}`, function () {
        const _this = $(this);
        const otherValueEl = $(`#${field}_other_value`);
        const otherValueFG = otherValueEl.closest('.form-group');
        let showed;
        if (_this.val() === enums[field]) {
            otherValueFG.removeClass('d-none');
            showed = true;
        } else {
            otherValueEl.val('');
            otherValueFG.addClass('d-none');
            showed = false;
        }
        callback?.(showed, otherValueEl, _this);
    });
}

window.objectToQueryParam = (data, parentKey = null) => {
    const queryParams = [];

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            const value = data[key];
            const fullKey = parentKey ? `${parentKey}[${key}]` : key;

            if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    value.forEach((arrayValue, index) => {
                        queryParams.push(objectToQueryParam(arrayValue, `${fullKey}[${index}]`));
                    });
                } else {
                    queryParams.push(objectToQueryParam(value, fullKey));
                }
            } else {
                const encodedKey = encodeURIComponent(fullKey);
                const encodedValue = encodeURIComponent(value);
                queryParams.push(`${encodedKey}=${encodedValue}`);
            }
        }
    }

    return queryParams.join('&');
}
